<template>
  <div>
    <b-card class="m-2" no-body>
      <b-card-body>
        <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
          <b-form class="p-2" @submit.prevent="handleSubmit(onSubmit)">
            <b-row>
              <b-col cols="6" md="6" class="mb-md-0 mb-2">
                <label class="my-2 text-capitalize">{{
                  $t("digital_signature.file_video")
                }}</label>
                <vue-dropzone
                  id="dropzone_file"
                  ref="dropzoneFileVideo"
                  :options="dropzoneOptionsVideo"
                  class="dropzone-file"
                  @vdropzone-file-added="addFileVideo"
                  @vdropzone-removed-file="removeFileVideo"
                />
              </b-col>
              <b-col cols="6" md="6" class="mb-md-0 mb-2">
                <label class="my-2 text-capitalize">{{
                  $t("digital_signature.file_signature")
                }}</label>
                <vue-dropzone
                  id="dropzone_file"
                  ref="dropzoneFileSignature"
                  :options="dropzoneOptionsSig"
                  class="dropzone-file"
                  @vdropzone-file-added="addFileSignature"
                  @vdropzone-removed-file="removeFileSignature"
                />
              </b-col>
            </b-row>
            <div class="d-flex mt-2 justify-content-center alig-items-center">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mr-2 text-capitalize"
                type="submit"
              >
                {{ $t("actions.validate") }}
              </b-button>
            </div>
          </b-form>
        </validation-observer>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import { BCard, BRow, BFormFile } from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { ref } from "@vue/composition-api";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import Breadcrumb from "@/components/Breadcrumb.vue";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import Ripple from "vue-ripple-directive";
import axios from "@axios";

export default {
  components: {
    Breadcrumb,
    BFormFile,
    BCard,
    BRow,
    ToastificationContent,
    ValidationProvider,
    ValidationObserver,
    vueDropzone: vue2Dropzone,
  },
  directives: {
    Ripple,
  },

  setup(_, context) {

    const { t } = useI18nUtils();
    const loadingToast = ref(null);
    const toast = useToast();
    const itemData = ref([]);
    const dropzoneFileVideo = ref(null);
    const dropzoneFileSignature = ref(null);

    const dropzoneOptionsVideo = ref({
      url: "https://httpbin.org/post",
      paramName: "file",
      autoProcessQueue: false,
      addRemoveLinks: true,
      dictRemoveFile: t("actions.delete"),
      acceptedFiles: [".mov", ".mp4", ".avi", ".flv"],
      maxFilesize: 1000,
      dictDefaultMessage: t("messages.import.select_file") + " (.mov .mp4 .avi .flv)",
    });

    const dropzoneOptionsSig = ref({
      url: "https://httpbin.org/post",
      paramName: "file",
      autoProcessQueue: false,
      addRemoveLinks: true,
      dictRemoveFile: t("actions.delete"),
      acceptedFiles: ".sig",
      maxFilesize: 200,
      dictDefaultMessage: t("messages.import.select_file") + " (.sig)",
    });

    const addFileVideo = (file) => {
      dropzoneFileVideo.value = file;
    };
    const removeFileVideo = () => {
      dropzoneFileVideo.value = null;
    };

    const addFileSignature = (file) => {
      dropzoneFileSignature.value = file;
    };
    const removeFileSignature = () => {
      dropzoneFileSignature.value = null;
    };

    const onSubmit = async () => {
      if (
        dropzoneFileVideo.value == null ||
        dropzoneFileSignature.value == null
      )
        return;

      const formData = new FormData();
      formData.append("file_video", dropzoneFileVideo.value);
      formData.append("file_sig", dropzoneFileSignature.value);

      axios
        .post("/v1/share_video_link/validate_video_signature", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          if (response.data.success) {
            toast({
              component: ToastificationContent,
              props: {
                title: response.data.message,
                icon: "CheckIcon",
                variant: "success",
              },
            });
          } else {
            toast({
              component: ToastificationContent,
              props: {
                title: response.data.message,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          }
        })
        .catch((response) => {
          toast({
            component: ToastificationContent,
            props: {
              title: response.data.message,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    };

    return {
      onSubmit,
      loadingToast,
      itemData,
      dropzoneOptionsVideo,
      dropzoneOptionsSig,
      addFileVideo,
      removeFileVideo,
      addFileSignature,
      removeFileSignature,
    };
  },
};
</script>

<style lang="scss">
.dropzone-file {
  padding: 0px;
  margin: auto;
  border: none;
  max-width: 100%;
  min-height: 200px;
  display: flex;
  box-shadow: inset 0 0 0 3px #dfdfdf;
}

.dropzone {
  .dz-preview {
    margin: 0px;
    width: 100%;
  }

  .dz-message {
    text-align: center;
    margin: auto;
  }
}
</style>
